import { Directive, effect, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Directive({
  selector: '[splUiIcon]',
})
export class SplUiIcon {
  private readonly matIcon = inject(MatIcon);

  readonly iconName = input.required<string>({ alias: 'splUiIcon' });

  constructor() {
    this.matIcon.fontSet = 'ti';

    effect(() => {
      this.matIcon.fontIcon = `ti-${this.iconName()}`;
    });
  }
}
